import { Link } from 'react-router-dom';
import useAdminData from './useAdminData';
import { fetchAgents } from '../../services/adminStatsService';

export default function AdminAgents() {
  const { data, loading, error } = useAdminData(fetchAgents);

  if (loading) return <div className="text-gray-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;

  const rows = data?.data || [];
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50 text-gray-600 text-xs uppercase">
          <tr>
            <Th>Agent</Th>
            <Th>Role</Th>
            <Th>Markets</Th>
            <Th align="right">Messages sent</Th>
            <Th align="right">Assigned open</Th>
            <Th align="right">Closed in range</Th>
            <Th align="right">Avg first reply (min)</Th>
            <Th>Last activity</Th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.userId} className="border-t border-gray-100 hover:bg-gray-50">
              <Td>
                <Link to={`/admin/agents/${r.userId}`} className="text-blue-600 hover:underline">
                  {r.name}
                </Link>
                <div className="text-xs text-gray-500">{r.email}</div>
              </Td>
              <Td>{r.role}</Td>
              <Td>{(r.markets || []).join(', ')}</Td>
              <Td align="right">{r.messagesSent.toLocaleString()}</Td>
              <Td align="right">{r.assignedOpen.toLocaleString()}</Td>
              <Td align="right">{r.closedInRange.toLocaleString()}</Td>
              <Td align="right">{r.avgFirstResponseMin ?? '—'}</Td>
              <Td>{r.lastActivityAt ? new Date(r.lastActivityAt).toLocaleString() : '—'}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function Th({ children, align = 'left' }) {
  return <th className={`px-3 py-2 text-${align} font-medium`}>{children}</th>;
}
function Td({ children, align = 'left' }) {
  return <td className={`px-3 py-2 text-${align}`}>{children}</td>;
}
